module.exports = __webpack_public_path__ + "static/media/yash-solution.881418db.png";